/*
  Portfolio page for FullStack.cash
*/

import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Container, Row, Col, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import walletThumbnail from '../assets/images/wallet-fullstack-thumbnail.png'
import nftCreatorThumbnail from '../assets/images/nft-creator-thumbnail.png'
import nftCollectorThumbnail from '../assets/images/nft-collector.gif'
import bchDexThumbnail from '../assets/images/bch-dex-thumbnail.png'
import wordpressStoreScreenshot from '../assets/images/wordpress-store-screenshot.png'
import chatBotScreenshot from '../assets/images/chat-bot.png'

function Portfolio () {
  const portfolioItems = [
    {
      title: 'Wallet.FullStack.cash',
      image: walletThumbnail,
      link: 'http://bchn-wallet.fullstack.cash',
      description: 'Our open source, white-label wallet. It provides a foundation upon which to build additional functionality. We encourage developers and businesses to fork this code base and customize it for their own needs.',
      features: [
        'Create or import new wallets using a 12-word mnemonic.',
        'Send and receive BCH.',
        'Send and receive tokens, including NFTs.',
        'Sweep BCH or tokens from a paper wallet.'
      ]
    },
    {
      title: 'NFT Creator',
      image: nftCreatorThumbnail,
      link: 'https://nft-creator.fullstack.cash/',
      description: 'NFTs are the future of digital assets. They can represent anything from concert tickets, to works of art, to news items, to membership in a club, to just about anything you can imagine. Creating NFTs needs to be cheap and easy. This app let\'s you create an NFT in a few seconds for only a few cents of BCH.'
    },
    {
      title: 'NFT Collector',
      image: nftCollectorThumbnail,
      link: 'https://nft-collector.fullstack.cash/?addr=bitcoincash:qzsgnyd826c6xw5y3y4ct6q2gvf3r8fmkqfvtzn6ef',
      description: 'What good is it to create NFTs if you can\'t show them off?! The NFT Collector app will display any NFTs held by a Bitcoin Cash address. The address can be passed as part of the URL, which makes it easy to share on social media.'
    },
    {
      title: 'Decentralized Exchange (DEX)',
      image: bchDexThumbnail,
      link: 'https://dex.fullstack.cash/',
      description: 'FullStack.cash and the PSF are in the process of building out a decentralized exchange (DEX) for trading tokens on the BCH, eCash, and AVAX blockchains. These DEX\'s can be used to buy and sell fungible tokens and NFTs. The protocol we\'ve developed is trustless, atomic, non-custodial, and peer-to-peer.'
    },
    {
      title: 'Sell Products for BCH',
      image: wordpressStoreScreenshot,
      link: 'https://bchstore.com/',
      description: 'Many clients want a simple store where they can sell products for Bitcoin Cash or tokens. For this specific use case, we can set up a Wordpress website running a WooCommerce plugin that supports sales in BCH. This provides an industry-standard user interface for creating an online store, managing inventory, and accepting BCH for payment.'
    },
    {
      title: 'Telegram and Discord Bots',
      image: chatBotScreenshot,
      link: 'https://t.me/permissionless_software',
      description: 'Crypto is all about community. But in order to communicate with your community, you must be able to filter out noise makers and spam bots. FullStack.cash can create a custom chat bot to amplify the signal and reduce the noise. We can produce a custom bot for you that silences all newcomers by default. They can gain the ability to speak in your Telegram or Discord channel by completing a challenge, such as signing a message or claiming a token.'
    }
  ]

  return (
    <>
      <Helmet>
        <title>Portfolio - FullStack.cash</title>
      </Helmet>

      <Container className='py-5'>
        <Row className='mb-5'>
          <Col>
            <h2 className='text-center mb-4'>Crypto Apps Built by FullStack.cash</h2>
            <p className='text-center'>
              This page is a collection of apps built by FullStack.cash. These
              are examples of the kinds of apps we build for clients. All apps
              on this page are open source, and we encourage companies to copy{' '}
              <a
                href='https://github.com/Permissionless-Software-Foundation'
                target='_blank'
                rel='noreferrer'
              >
                our code
              </a>
              . We <Link to='/consulting'>can be hired</Link> to build apps for
              you too.
            </p>
          </Col>
        </Row>

        {portfolioItems.map((item, index) => (
          <Row key={index} className='mb-5'>
            <Col md={6} className='mb-4 mb-md-0'>
              <a href={item.link} target='_blank' rel='noreferrer'>
                <img src={item.image} alt={item.title} className='img-fluid' />
              </a>
            </Col>
            <Col md={6}>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              {item.features && (
                <ul>
                  {item.features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>
              )}
              <Button
                href={item.link}
                target='_blank'
                rel='noreferrer'
                variant='primary'
              >
                Live Demo
              </Button>
            </Col>
          </Row>
        ))}
      </Container>
    </>
  )
}

export default Portfolio
